import { getGlobal } from 'reactn';
import { RetailerOptConfigRich } from '../components/ConfigurationForm/ConfigurationFormSchema';
import { APApiFactory } from '../gen/api/api';
import { Configuration } from '../gen/api/configuration';
import { format } from 'date-fns';

const CONFIGURATION_API_BASE_URL = '/api';

function getRetailerOptConfigFromFormValues(configuration: RetailerOptConfigRich) {
    return {
        id: configuration.id,
        type: configuration.type,
        programId: configuration.program?.id || 0,
        retailerId: configuration.retailer?.id || 0,
        name: configuration.name,
        description: configuration.description,
        startDateTime: format(new Date(configuration.startDateTime), "yyyy-MM-dd'T'hh:mm:ss"),
        endDateTime: format(new Date(configuration.endDateTime), "yyyy-MM-dd'T'hh:mm:ss"),
        status: configuration.status,
        createdAt: configuration.createdAt,
        createdBy: configuration.createdBy,
        updatedAt: configuration.updatedAt,
        updatedBy: configuration.updatedBy,
        version: configuration.version,
        rules: configuration.rules,
    };
}

export default function ApiService() {
    const apiServiceConfiguration = new Configuration({
        basePath: CONFIGURATION_API_BASE_URL,
        accessToken: getGlobal().keycloakState.keycloak?.token,
    });

    const factory = APApiFactory(apiServiceConfiguration, CONFIGURATION_API_BASE_URL);

    return {
        fetchConfigurations() {
            return factory.getConfigurations();
        },
        fetchConfigurationById(configurationId: string) {
            return factory.getConfigurationByID(configurationId);
        },
        addConfiguration(configuration: RetailerOptConfigRich) {
            return factory.createConfiguration(getRetailerOptConfigFromFormValues(configuration));
        },
        editConfiguration(configuration: RetailerOptConfigRich) {
            if (configuration.id) {
                return factory.updateConfiguration(
                    configuration.id,
                    configuration.version!,
                    getRetailerOptConfigFromFormValues(configuration),
                );
            }
        },
        fetchPrograms(searchTerm?: string) {
            return factory.getPrograms(searchTerm);
        },
        fetchProgramById(programId: number) {
            return factory.getProgramById(programId);
        },
        fetchRetailers(searchTerm?: string) {
            return factory.getParticipants(searchTerm);
        },
        fetchRetailerById(retailerId: number) {
            return factory.getParticipantById(retailerId);
        },
        fetchMarkets(searchTerm?: string) {
            return factory.getMarkets(searchTerm);
        },
        fetchRetailersByMarketIds(marketIds?: number[], searchTerm?: string) {
            return factory.getParticipantsByMarketIds(marketIds, searchTerm);
        },
        fetchMarketById(marketId: number) {
            return factory.getMarketById(marketId);
        },
        fetchCodeListByName(name: string) {
            return factory.getCodeListByName(name);
        },
        fetchOffers(searchTerm?: string) {
            return factory.getOffers(searchTerm);
        },
        fetchOfferById(offerId: number) {
            return factory.getOfferById(offerId);
        },
        fetchRuleDefinitions() {
            return factory.getRuleDefinitions();
        },
        fetchAuditTrails(configurationId?: string) {
            return factory.getConfigurationAuditTrails(configurationId);
        },
        uploadAsset(file: any) {
            return factory.uploadAsset(file);
        },
    };
}
